var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#E5E5E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveStepIcon);
export default __webpack_public_path__ + "static/media/inactive-step-icon.a0ad41a76b4b97af6495968c8019486f.svg";
export { ForwardRef as ReactComponent };